<template>
  <!-- 盒子管理-盒子奖品-价格设置 -->
  <div>
    <el-dialog
      :visible.sync="showMark"
      :close-on-click-modal="false"
      title="价格设置"
      width="1000px"
      @close="closeDialog"
      center
    >
      <el-table
        height="400px"
        class="from-overview"
        v-loading="loading"
        :data="dataList"
      >
        <el-table-column prop="id" label="ID" align="center"> </el-table-column>
        <el-table-column prop="name" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="price" label="价格" width="180" align="center">
        </el-table-column>
        <el-table-column
          prop="ig_prize"
          label="IG价格"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="true_probability"
          label="真实概率"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="openEditDialog(row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </el-dialog>
    <el-dialog
      :visible.sync="editVisible"
      :close-on-click-modal="false"
      title="价格设置"
      width="350px"
      @close="editVisible = false"
      center
    >
      <el-form
        v-if="fromData"
        :model="fromData"
        ref="fromData"
        label-width="80px"
        size="small"
        :rules="goodRules"
      >
        <el-form-item prop="price" label="价格">
          <el-input
            v-model.trim="fromData.price"
            placeholder="请输入价格"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { server, postData, delData, patchData, getData, postApiData } from '../../http'

export default {
  components: {
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    visible: {//展示标志
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editVisible: false,//编辑弹窗显示标志
      loading: false,//加载动画
      buttonLoading: false,//加载按钮动画
      dataList: undefined,//数据列表
      fromData: {//表单数据
        id:undefined,
        price: undefined
      },
      dataMeta: undefined,//不底部分页
      goodRules: { //验证规则
        price: [{
          required: true,
          message: '请输入价格'
        },]
      }
    }
  },
  computed: {
    ...mapState({
    }),
    showMark: {
      get() {
        return this.visible
      },
      set(bool) {
      }
    },
    boxId: {
      get() {
        return this.value
      },
      set(bool) {
      }
    }
  },
  watch: {
    showMark(val) {
      if (val && this.value) {
        this.getData()//获取数据列表
      }
    }
  },
  created() {
  },
  mounted() { },
  methods: {
    ...mapMutations(['']),
    ...mapActions(['']),
    getData() {
      //获取数据列表
      this.loading = true
      getData(`battle_price/${Number(this.boxId)}`)
        .then(res => {
          this.dataList = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    openEditDialog(rowInfo) {
      //打开编辑弹
      this.editVisible = true
      this.fromData.price = JSON.parse(JSON.stringify(rowInfo.price))
      this.fromData.id = JSON.parse(JSON.stringify(rowInfo.id))
    },
    submit() {
      //编辑保存提交
      this.$refs['fromData'].validate((valid) => {
        postData(`battle_price_set/${Number(this.fromData.id)}`, {
          price: this.fromData.price
        })
          .then(res => {
            this.$message.success("编辑成功！")
            this.getData()
          })
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }

  }

}
</script>
<style lang="less" scoped>
</style>